<template>
    <Table :properties="tableProperties">
        <template v-slot:searchFields="">
            <v-col cols="12" class="pb-0">
                <v-text-field hide-details clearable outlined reverse dense :label="$t('field.SERNUM')" :rules="rules"
                    v-model="serialNumber" :disabled="tableProperties.loading" @keypress.enter="getData" />
            </v-col>
        </template>
    </Table>
</template>
<script>
import { API } from 'aws-amplify'
import Table from '../components/Table'

export default {
    name: 'Parts2',
    components: { Table },
    data() {
        return {
            rules: [value => !value || this.validateInput()],
            serialNumber: '',
            tableProperties: {
                items: [],
                sortBy: ['DATEOPEN', 'YHV_KARTISNO', 'YHV_CLAIMTYPE'],
                sortDir: [true, true, true],
                loading: false,
                getData: this.getData,
                itemsPerPage: 100,
                submitBtn: { disabled: true },
                headers: [
                    { text: this.$t('field.DATEOPEN'), value: 'DATEOPEN', width: '105px' },
                    { text: this.$t('field.DATECLOSE'), value: 'DATECLOSE', width: '105px' },
                    { text: this.$t('field.YHV_KARTISNO'), value: 'YHV_KARTISNO' },
                    { text: this.$t('field.TYPE'), value: 'TYPE' },
                    { text: this.$t('field.PARTDES2'), value: 'PARTDES' },
                    { text: this.$t('field.RQUANTORTIME'), value: 'RQUANT' },
                    { text: this.$t('field.MADUZ'), value: 'MADUZ' },
                    { text: this.$t('field.PARTNAME2'), value: 'PARTNAME' },
                    { text: this.$t('field.YHV_MEMBERNAME'), value: 'YHV_MEMBERNAME' }
                ]
            }
        }
    },
    methods: {
        validateInput() {
            let valid = !!(this.serialNumber || '').match(/^\d+$/)
            this.tableProperties.submitBtn.disabled = !valid
            return valid
        },
        getData() {
            if (!this.validateInput()) return

            this.items = []
            this.tableProperties.loading = true
            API.get('priority', `/apiv1/history?SERNUM=${this.serialNumber}`, null)
                .then(res => this.tableProperties.items = res)
                .finally(() => this.tableProperties.loading = false)
        }
    }
}
</script>
  